import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = [
    "name"
];
const _hoisted_2 = [
    "name"
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
    const _component_van_tabbar = _resolveComponent("van-tabbar");
    return _openBlock(), _createBlock(_component_van_tabbar, {
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.activeTab = $event),
        fixed: false,
        "active-color": "var(--color-text)",
        "inactive-color": "var(--color-text-light)",
        onChange: _ctx.handleTabbarChange
    }, {
        default: _withCtx(()=>[
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listAuthed, (item, index)=>{
                    return _openBlock(), _createBlock(_component_van_tabbar_item, {
                        key: index,
                        replace: "",
                        to: item.link
                    }, {
                        icon: _withCtx((scope)=>[
                                scope.active ? (_openBlock(), _createElementBlock("pg-icon", {
                                    key: 0,
                                    class: "pe-tabbar-icon",
                                    name: item.iconActive
                                }, null, 8, _hoisted_1)) : (_openBlock(), _createElementBlock("pg-icon", {
                                    key: 1,
                                    class: "pe-tabbar-icon",
                                    name: item.icon
                                }, null, 8, _hoisted_2))
                            ]),
                        default: _withCtx(()=>[
                                _createTextVNode(" " + _toDisplayString(item.name), 1)
                            ]),
                        _: 2
                    }, 1032, [
                        "to"
                    ]);
                }), 128))
            ]),
        _: 1
    }, 8, [
        "modelValue",
        "onChange"
    ]);
}
